import { useEffect, useState } from "react"
import { storyblokRoutesPaths } from "@/routes/storyblok"
import { useStoryblokBreadcrumb } from "../../../../hooks/useStoryblokBreadcrumb"
import { fetchSbStories } from "../../../../lib/api"
import { type SbFaqArticleStory, type SbFaqCategoryStory } from "../../../../types"
import { getParams } from "../../../../utils/getParams"
import { StoryblokFAQCategory } from "../../../FAQCategory"

type FaqCategoryTemplateProps = {
    story: SbFaqCategoryStory
}

export function FaqCategoryTemplate({ story }: FaqCategoryTemplateProps) {
    const { title } = story.content
    const [stories, setStories] = useState<Array<SbFaqArticleStory>>([])
    const [isLoading, setIsLoading] = useState(true)
    const crumbs = useStoryblokBreadcrumb({
        story,
        root: { href: storyblokRoutesPaths.faq.resolve(), title: "FAQ" },
    })

    const options = getParams(false, {
        starts_with: `/${story.slug}`,
        excluding_ids: story.id.toString(),
        content_type: "faqCategory",
    })

    useEffect(() => {
        const fetchStories = async () => {
            try {
                const stories = await fetchSbStories({
                    starts_with: story.full_slug,
                    excluding_ids: story.id.toString(),
                    content_type: "faqArticle",
                })

                setStories(stories)
            } catch (error) {
                console.error(`Could not find stories with category slug ${story.full_slug}`, error)
            }

            setIsLoading(false)
        }

        void fetchStories()
    }, [story.full_slug, story.id])

    return (
        <StoryblokFAQCategory
            crumbs={crumbs}
            title={title}
            options={options}
            stories={stories}
            isLoading={isLoading}
        />
    )
}
